import { gql } from '@apollo/client';

export const CREATE_MEDIA_UPLOADS = gql`
  mutation CreateMediaUploads($data: CreateMediaUploadsInput!) {
    createMediaUploads(data: $data) {
      message
    }
  }
`;

export const UPDATE_MEDIA_UPLOAD = gql`
  mutation UpdateMediaUpload(
    $where: CommonIdInput!
    $data: UpdateMediaUploadInput!
  ) {
    updateMediaUpload(where: $where, data: $data) {
      message
    }
  }
`;
